export const I_ARRAYS = {
  I_dailyInterestAccounts: 'I_dailyInterestAccounts',
  I_highYieldAccounts: 'I_highYieldAccounts',
  I_guaranteedInterestAccounts: 'I_guaranteedInterestAccounts',
  I_benevaInvestmentAccounts: 'I_benevaInvestmentAccounts',
  I_benevaGuaranteedInvestmentFunds: 'I_benevaGuaranteedInvestmentFunds',
} as const;

export const I_ARRAY_ADD_BUTTONS = {
  I_dailyInterestAccounts: 'I102',
  I_benevaInvestmentAccounts: 'I143',
  I_guaranteedInterestAccounts: 'I144',
  I_highYieldAccounts: 'I184',
  I_benevaGuaranteedInvestmentFunds: 'I185',
} as const;

export const I_PREFILLED_ACCOUNTS = {
  I_selectSourceOfFundsButton: 'I212',
  I_selectSourceOfFundsModal: 'I_selectSourceOfFundsModal',
};

export const ALL_I_ARRAYS = Object.values(I_ARRAYS);
export const ALL_I_ARRAY_ADD_BUTTONS = Object.values(I_ARRAY_ADD_BUTTONS);

export type I_Array = (typeof ALL_I_ARRAYS)[number];
